type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  light?: boolean;
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  light = false,
}: SectionHeadingProps) {
  return (
    <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <p
          className={`mb-3 inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase ${
            light ? "text-accent-300" : "text-primary-600"
          }`}
        >
          <span className={`h-px w-6 ${light ? "bg-accent-400" : "bg-primary-400"}`}></span>
          {eyebrow}
        </p>
      )}
      <h2
        className={`font-heading text-2xl font-bold leading-snug md:text-4xl text-balance ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-4 text-sm leading-relaxed md:text-base ${
            light ? "text-background-100/80" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}